export const formatListWithOverflow = (
  items: string[],
  maxVisible: number
): string => {
  if (items.length <= maxVisible) {
    return items.join(', ')
  }
  const visible = items.slice(0, maxVisible).join(', ')
  return `${visible} + ${items.length - maxVisible} more`
}
